export default "__VITE_ASSET__BFB$S0d3__"